import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { MarkdownText } from '@/shared/MarkdownText';
import { type FC } from 'react';

export const WarningModal: FC<{
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  isLoading: boolean;
  onConfirm: () => void;
  criteriaCount: number;
  screeningDecisionsCount: number;
  validatedCount: number;
}> = ({
  isOpen,
  onOpenChange,
  isLoading,
  onConfirm,
  screeningDecisionsCount,
  criteriaCount,
  validatedCount,
}) => {
  const markdownText = `
Changing your search criteria means all papers need to be re-screened.

This will:
- Delete all ${screeningDecisionsCount} screening decisions (including ${validatedCount} validated papers)
- Remove any manual overrides or edits you've made
- Replace your ${criteriaCount} existing exclusion criteria

⚠️ This action cannot be undone.
`;

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="pr-2">
            This action will generate a new screening based on your updated
            search.
          </DialogTitle>
        </DialogHeader>
        <MarkdownText>{markdownText}</MarkdownText>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button variant="destructive" onClick={onConfirm} loading={isLoading}>
            Yes, generate screening
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
